export const DEVICE_TYPE = {
  desktop: 'DESKTOP',
  tablet: 'TABLET',
  mobile: 'MOBILE',
}

export const X_DEVICE_DESKTOP = 'desktop-admin'
export const X_DEVICE_MOBILE = 'mobile-web-admin'
